import { FC } from 'react';
import { Track, Tracks } from './styles';

interface TracksProps {
  clickEnabled: any;
  onClick?: (event: React.BaseSyntheticEvent) => void;
  steps: any;
  styles: any;
  padding?: number;
}

const TracksComponent: FC<TracksProps> = props => {
  const { clickEnabled, onClick, steps, styles, padding } = props;
  return (
    <Tracks padding={padding} clickEnabled={undefined}>
      {steps.map((_: any, index: number) => (
        <Track className={styles[index]} clickEnabled={clickEnabled} onClick={onClick} key={index} value={index}>
          <div className="side-nav__wrap">
            <div className="side-nav__circle">
              <div className="side-nav__circle-inner" />
              <div className="side-nav__line" />
            </div>
            <span className="side-nav__page">{steps[index].name}</span>
          </div>
        </Track>
      ))}
    </Tracks>
  );
};

TracksComponent.defaultProps = {
  clickEnabled: true,
};

export default TracksComponent;
